import * as React from "react";
const NewsUp3 = (props) => (
  <svg
    width={15}
    height={9}
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.40386 1.59404L1.11501 7.79673C0.855774 8.05241 0.440251 8.04759 0.186915 7.78595C-0.0664206 7.52431 -0.0616379 7.10493 0.197599 6.84925L6.9508 0.188568C7.20806 -0.0651684 7.61975 -0.0626268 7.87391 0.194265L14.8081 7.20282C15.0642 7.46168 15.0639 7.88108 14.8074 8.13958C14.551 8.39807 14.1354 8.39777 13.8793 8.13891L7.40386 1.59404Z"
      fill="#012272"
    />
  </svg>
);
export default NewsUp3;
